export default __webpack_public_path__ + "static/material-icons-regular-cff684e59ffb052d72cb8d5e49471553.woff2";